export const FilterPopup = ({ open, onClose, children }) => {
  if (!open) return null;

  return (
    <div style={popupStyles.overlay} onClick={onClose}>
      <div style={popupStyles.popup} onClick={e => e.stopPropagation()}>
        <div style={popupStyles.header}>
          <span>Filters</span>
          <button onClick={onClose} style={popupStyles.closeBtn}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
};

const popupStyles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15,23,42,0.45)",   // darker, premium
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },

  popup: {
    width: "360px",
    background: "#ffffff",
    borderRadius: "14px",
    padding: "14px",
    boxShadow:
      "0 25px 50px -12px rgba(0,0,0,0.25), 0 10px 20px rgba(0,0,0,0.12)",
    animation: "scaleIn 0.15s ease-out",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "12px",
    fontWeight: 800,
    color: "#0f172a",
    borderBottom: "1px solid #e2e8f0",
    paddingBottom: "8px",
    marginBottom: "10px",
    letterSpacing: "0.3px",
  },

  closeBtn: {
    background: "#f1f5f9",
    border: "1px solid #cbd5e1",
    borderRadius: "50%",
    width: "22px",
    height: "22px",
    fontSize: "12px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

